/* eslint-disable import/no-mutable-exports */
const env = process.env.REACT_APP_ENV;
let envValues = {
  PORT: 80,
  REACT_APP_CLIENT_PUBLIC_IMAGES_URL: 'http://localhost:3000/images',
  REACT_APP_API_ENDPOINT: 'http://localhost:4075/v1',
  REACT_APP_API_FRONT_END: 'http://localhost:4075',
  REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
  REACT_APP_SHOW_COOKIE_BOX: false,
  SOCKET_STATUS: 'ON',
  FIREBASE_CONFIG: {},
  COLLECTIONURL: 'notifications',
};
switch (env) {
  case 'staging':
    envValues = {
      PORT: 80,
      REACT_APP_CLIENT_PUBLIC_IMAGES_URL: 'https://manage-freemedia.iscriptsdemo.com/images',
      REACT_APP_API_ENDPOINT: 'https://api-freemedia.iscriptsdemo.com/v1',
      REACT_APP_API_FRONT_END: 'manage-freemedia.iscriptsdemo.com',
      REACT_APP_API_PERMISSION_DENIED: 'https://api-freemedia.iscriptsdemo.com/v1',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      FIREBASE_CONFIG: {},
      COLLECTIONURL: 'notifications',
    };
    break;
  case 'production':
    envValues = {
      PORT: 80,
      REACT_APP_CLIENT_PUBLIC_IMAGES_URL: 'https://manage.freemedia.global/images',
      REACT_APP_API_ENDPOINT: 'https://api.freemedia.global/v1',
      REACT_APP_API_FRONT_END: 'manage.freemedia.global',
      REACT_APP_API_PERMISSION_DENIED: 'https://api.freemedia.global/v1',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      FIREBASE_CONFIG: {},
      COLLECTIONURL: 'notifications',
    };
    break;
  case 'development':
    envValues = {
      PORT: 80,
      REACT_APP_CLIENT_PUBLIC_IMAGES_URL: 'http://localhost:3000/images',
      REACT_APP_API_ENDPOINT: 'http://localhost:4076/v1',
      REACT_APP_API_FRONT_END: 'http://localhost:4075',
      REACT_APP_API_PERMISSION_DENIED: 'http://localhost:3000/permission',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      FIREBASE_CONFIG: {},
      COLLECTIONURL: 'notifications',
    };
    break;
  default:
    envValues = {
      PORT: 80,
      REACT_APP_CLIENT_PUBLIC_IMAGES_URL: 'http://localhost:3000/images',
      REACT_APP_API_ENDPOINT: '',
      REACT_APP_API_FRONT_END: '',
      REACT_APP_API_PERMISSION_DENIED: '',
      REACT_APP_SHOW_COOKIE_BOX: false,
      SOCKET_STATUS: 'ON',
      FIREBASE_CONFIG: {},
      COLLECTIONURL: 'notifications',
    };
    break;
}

export default envValues;
